import LuckImage from "@/assets/img/today/horoscope/sights_of_luck_image.webp"
import DiceImage from "@/assets/img/today/horoscope/dice.webp"

import { QUIET_SIGNS } from "../../config/horoscope-content"

interface QuietSignsProps {
  onAsk: () => void
}

/** "Quiet Signs of Luck" summary card. Ported from Horoscope QuietSignsOfLuck. */
export function QuietSigns({ onAsk }: QuietSignsProps) {
  return (
    <div className="mx-4 mt-10 overflow-hidden rounded-[32px] bg-dark-surface px-4 py-6">
      <div className="flex flex-col gap-4">
        <div className="flex flex-col gap-1">
          <p className="font-body text-sm text-purple-light/40">{QUIET_SIGNS.label}</p>
          <h3 className="font-display text-2xl font-medium text-purple-light">
            {QUIET_SIGNS.title}
          </h3>
        </div>
        <p className="font-body text-base text-purple-light/70">{QUIET_SIGNS.description}</p>
      </div>

      <div className="-mx-4 -mb-10 mt-4 w-[calc(100%+32px)]">
        <img src={LuckImage} alt="" className="block w-full" />
      </div>

      <div className="flex flex-col gap-6">
        <div className="h-px w-full bg-purple-light/10" />
        <div className="flex items-center gap-3">
          <img src={DiceImage} alt="" className="size-14" />
          <p className="flex-1 font-body text-sm text-purple-light/70">
            Want to know where <span className="font-medium text-white">luck</span> may show up
            today?
          </p>
          <button
            type="button"
            onClick={onAsk}
            className="flex h-12 shrink-0 items-center justify-center rounded-full bg-gradient-to-b from-peach to-purple-accent px-8 font-body text-base font-semibold text-white"
          >
            Ask advisor
          </button>
        </div>
      </div>
    </div>
  )
}
